export interface Invitation {
  id: string; // UUID
  recruiterId: string;
  candidateId: string;
  jobTemplateId: string;

  invitationStatus: string; // "pending" | "Accepted" | "Rejected"
  message: string;

  createdAt: string; // ISO string
  updatedAt: string; // ISO string

    // ✅ ADD THIS
  jobSummarySlug?: string; 
}


export const initialInvitation: Invitation = {
  id: "",
  recruiterId: "",
  candidateId: "",
  jobTemplateId: "",

  invitationStatus: "pending",
  message: "",

  createdAt: "",
  updatedAt: "",
  jobSummarySlug: "", // ✅ ADD THIS
};


export interface InvitationRequest {
  id: string; // UUID
  recruiterId: string;
  candidateId: string;
  jobTemplateId: string;

  invitationStatus: string; // "pending" | "Accepted" | "Rejected"
  message: string;

  createdAt: string; // ISO string
  updatedAt: string; // ISO string
}


export interface InvitationResponse {
  id: string; // UUID
  recruiterId: string;
  candidateId: string;
  jobTemplateId: string;

  invitationStatus: string; // "pending" | "Accepted" | "Rejected"
  message: string;
}


/**
 * Maps to RecruiterDetailsWithJobTemplateDetailsResponseDTO
 */
export interface JobInvitationResponse {
    // Identity & Status
    invitationId: string; // UUID
    recruiterId: string;  // UUID
    candidateId: string; 
    jobTemplateId: string; // UUID
    invitationStatus: 'PENDING' | 'ACCEPTED' | 'REJECTED' | 'EXPIRED'; 
    message: string;
    invitationCreatedAt: string; // ISO LocalDateTime string
    invitationUpdatedAt: string;

    // Job Template Info
    jobId: string;
    companyId: string;
    postedBy: string;
    jobTittle: string;
    jobDescription: string;
    jobSummarySlug: string;
    roleLevel: string;
    miniExperience: string;
    maxExperience: string;
    requiredOwnershipLevel: string[];
    requiredTeamSize: string;
    requiredTechSkills: string[];
    requiredDomain: string[];
    minBudgetHandled: string;
    expectedImpactLevel: string[];
    location: string[];
    workType: string;
    noticePeriodDays: number;
    compensationOffer: number; // Maps from BigDecimal
    jobStatus: boolean;
    jobCreatedAt: string;
    jobUpdatedAt: string;

    // Company Specific Info
    companyName: string;
    companyDomain: string;
    companyLogoUrl: string;
    industry: string;
    companySizeRange: string;
    website: string;
    description: string;
    headquartersLocation: string;
    createdAt: string;
    updatedAt: string;
}


/**
 * Maps to CompanyInvitationResponseDTO
 * Recruiter / company side invitation listing row.
 */
export interface CompanyInvitationResponse {
    invitationId: string;
    invitationStatus: 'PENDING' | 'ACCEPTED' | 'REJECTED' | 'EXPIRED' | string;
    message: string;

    recruiterId: string;
    recruiterName: string | null;
    recruiterEmail: string | null;

    candidateId: string;
    candidateName: string | null;
    candidateEmail: string | null;

    jobId: string;
    jobTitle: string | null;
    jobSummarySlug: string | null;

    companyId: string | null;
    companyName: string | null;
    companyLogoUrl: string | null;

    invitedAt: string | null;
    respondedAt: string | null;
    responseTimeInSeconds: number | null;
    createdAt: string | null;
    updatedAt: string | null;
}

/**
 * Aggregate counts for the company invitation listing.
 */
export interface CompanyInvitationStats {
    total: number;
    pending: number;
    accepted: number;
    rejected: number;
}


/**
 * Data sent to the backend when a candidate accepts or rejects
 */
export interface UpdateInvitationStatusRequest {
    invitationId: string;
    recruiterId: string;
    candidateId: string;
    jobTemplateId: string;
    invitationStatus: string; // "ACCEPTED" | "REJECTED"
    message: string;
}

export interface UpdateInvitationStatusResponse {
    invitationId: string;
    recruiterId: string;
    candidateId: string;
    jobTemplateId: string;
    invitationStatus: string; // "ACCEPTED" | "REJECTED"
    message: string;
}
